import type { GetAllUsers200ContentItemProvider } from './getAllUsers200ContentItemProvider';
import type { GetAllUsers200ContentItemStatus } from './getAllUsers200ContentItemStatus';

export type GetAllUsers200ContentItem = {
  /** 생성 시간 */
  createdAt: string;
  /** 이메일 주소 */
  email: string;
  /** 전체 이름 */
  fullName?: string;
  /** 사용자 ID */
  id: string;
  /** 마지막 로그인 시간 */
  lastLoginAt?: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 인증 제공자 */
  provider: GetAllUsers200ContentItemProvider;
  /** 사용자 권한 목록 */
  roles: string[];
  /** 계정 상태 */
  status: GetAllUsers200ContentItemStatus;
  /** 수정 시간 */
  updatedAt?: string;
  /** 사용자명 */
  username: string;
};
